import { myFetch, HttpMethod } from './baseService';

export interface TipoVehiculo {
  tvh_codigo: string;
  tvh_nombre: string;
  tvh_ruta_foto: string | null;
}

export interface TipoVehiculoResponse {
  code: string;
  message: string;
  object_: TipoVehiculo[];
}

export const obtenerTiposVehiculo = async () => {
  const response = await myFetch<TipoVehiculoResponse>(
    'tipo_vehiculo/ObtenerTodos',
    HttpMethod.POST,
    {}
  );

  return response;
};

